module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background-color": "#f3f1f1",
      "font-size": "0.28rem"
    }
  }, [_c('div', {
    staticStyle: {
      "background-image": "url( ../../../../static/Activity/2018HuaTie/Index/MainTop.jpg )",
      "background-size": "cover",
      "height": "3.2rem"
    }
  }, [_c('div', {
    staticStyle: {
      "color": "black",
      "padding": "0.35rem 0 0 0.35rem"
    }
  }, [(_vm.NowUser == '' && !_vm.openid) ? _c('div', {
    staticStyle: {},
    on: {
      "click": function($event) {
        return _vm.goLogout()
      }
    }
  }, [_vm._v("登录/注册")]) : (_vm.openid) ? _c('div', {
    staticStyle: {}
  }, [_vm._v("临时用户bhsdgsdgwe423")]) : _c('div', {
    staticStyle: {},
    on: {
      "click": function($event) {
        return _vm.goLogout()
      }
    }
  }, [_vm._v(_vm._s(this.NowUser) + " [注销]")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "line-height": "0.7rem",
      "height": "0.7rem",
      "overflow": "hidden",
      "font-size": "0.27rem"
    }
  }, [_c('div', {
    attrs: {
      "id": "MidLine"
    }
  }, [_vm._l((_vm.ShowList), function(item) {
    return _c('div', {
      key: item
    }, [_c('img', {
      staticStyle: {
        "width": "0.35rem"
      },
      attrs: {
        "src": require("../../../../static/Activity/2018HuaTie/Index/horn.png")
      }
    }), _vm._v("\n        " + _vm._s(item) + "\n      ")])
  }), _vm._v(" "), (_vm.ShowList.length == 0) ? _c('div', {
    staticStyle: {}
  }, [_c('img', {
    staticStyle: {
      "width": "0.35rem"
    },
    attrs: {
      "src": require("../../../../static/Activity/2018HuaTie/Index/horn.png")
    }
  }), _vm._v(" 恭喜用户138XXXX5647抽中￥200免房券\n      ")]) : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#333",
      "text-align": "center",
      "overflow": "hidden"
    }
  }, [_c('div', {
    staticClass: "CenterBox",
    class: {
      'OutBlue': _vm.ChoosePic % 9 == 0
    }
  }, [_c('img', {
    staticStyle: {},
    attrs: {
      "src": require("../../../../static/Activity/2018HuaTie/MidPic/Box0.jpg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "CenterBox",
    class: {
      'OutBlue': _vm.ChoosePic % 9 == 1
    }
  }, [_c('img', {
    staticStyle: {},
    attrs: {
      "src": require("../../../../static/Activity/2018HuaTie/MidPic/Box1.jpg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "CenterBox",
    class: {
      'OutBlue': _vm.ChoosePic % 9 == 2
    }
  }, [_c('img', {
    staticStyle: {},
    attrs: {
      "src": require("../../../../static/Activity/2018HuaTie/MidPic/Box2.jpg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "CenterBox",
    class: {
      'OutBlue': _vm.ChoosePic % 9 == 3
    }
  }, [_c('img', {
    staticStyle: {},
    attrs: {
      "src": require("../../../../static/Activity/2018HuaTie/MidPic/Box3.jpg")
    }
  })]), _vm._v(" "), _c('div', {
    class: {
      'OutBlue': _vm.ChoosePic % 9 == 4
    },
    staticStyle: {
      "margin": "0 0 0 3.3%",
      "float": "left"
    },
    on: {
      "click": function($event) {
        return _vm.HuaTie2018ChouJiang()
      }
    }
  }, [_c('img', {
    staticStyle: {
      "width": "2.2rem"
    },
    attrs: {
      "src": require("../../../../static/Activity/2018HuaTie/MidPic/Box4.png")
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "-1.1rem",
      "color": "white"
    }
  }, [_vm._v("(还有" + _vm._s(_vm.DrawTotal) + "次机会)")])]), _vm._v(" "), _c('div', {
    staticClass: "CenterBox",
    class: {
      'OutBlue': _vm.ChoosePic % 9 == 5
    }
  }, [_c('img', {
    staticStyle: {},
    attrs: {
      "src": require("../../../../static/Activity/2018HuaTie/MidPic/Box5.jpg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "CenterBox",
    class: {
      'OutBlue': _vm.ChoosePic % 9 == 6
    }
  }, [_c('img', {
    staticStyle: {},
    attrs: {
      "src": require("../../../../static/Activity/2018HuaTie/MidPic/Box6.jpg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "CenterBox",
    class: {
      'OutBlue': _vm.ChoosePic % 9 == 7
    }
  }, [_c('img', {
    staticStyle: {},
    attrs: {
      "src": require("../../../../static/Activity/2018HuaTie/MidPic/Box7.jpg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "CenterBox",
    class: {
      'OutBlue': _vm.ChoosePic % 9 == 8
    }
  }, [_c('img', {
    staticStyle: {},
    attrs: {
      "src": require("../../../../static/Activity/2018HuaTie/MidPic/Box8.jpg")
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "MainButtonBase",
    staticStyle: {
      "margin": "0.2rem 0 0.6rem 0",
      "background-color": "#ea5413",
      "box-shadow": "2px 2px 8px #aaa",
      "width": "50%",
      "margin-left": "25%"
    },
    on: {
      "click": function($event) {
        return _vm.GoIndex()
      }
    }
  }, [_c('div', {
    staticStyle: {
      "text-shadow": "1px 1px 6px #7a2b09"
    }
  }, [_vm._v("酒店预订")])]), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.toast) ? _c('mu-toast', {
    attrs: {
      "message": _vm.TellUser,
      "id": "alertline"
    },
    on: {
      "close": _vm.hideToast
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "1.7rem",
      "width": "100%"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ShowPage != 0),
      expression: "ShowPage != 0 "
    }],
    attrs: {
      "id": "bg_show"
    },
    on: {
      "click": function($event) {
        return _vm.CleanShadow()
      }
    }
  }), _vm._v(" "), (_vm.ShowPage == 1) ? _c('div', {
    staticStyle: {
      "position": "fixed",
      "top": "12%",
      "width": "100%",
      "z-index": "1002",
      "left": "10%"
    },
    on: {
      "click": function($event) {
        return _vm.CleanShadow()
      }
    }
  }, [_c('img', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "src": require("../../../../static/Activity/Tips/WXShare.png")
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.ShowPage == 11) ? _c('div', {
    staticClass: "ShadowTips",
    attrs: {
      "align": "center"
    }
  }, [_c('div', {}, [_c('img', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "src": '../../../../static/Activity/2018HuaTie/ShowPrize/弹窗-' + _vm.ResultItem.PrizeName + '.png'
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "relative",
      "width": "1.1rem",
      "height": "1.1rem",
      "margin-top": "-1.1rem"
    },
    on: {
      "click": function($event) {
        return _vm.CleanShadow()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "relative",
      "width": "3.5rem",
      "height": "0.8rem",
      "margin-top": "-2.8rem"
    },
    on: {
      "click": function($event) {
        return _vm.CleanShadow()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "relative",
      "width": "1.6rem",
      "height": "0.6rem",
      "margin-top": "-1.9rem",
      "margin-left": "2rem"
    },
    on: {
      "click": function($event) {
        return _vm.GoDown()
      }
    }
  })]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "color": "black",
      "background-color": "white",
      "box-shadow": "#e7d4d4 0px 0px 0.3rem",
      "margin": "0 4%",
      "padding": "0.3rem"
    }
  }, [_c('div', [_vm._v("活动规则：")]), _vm._v(" "), _c('div', [_vm._v("1.每个会员每天有3次抽奖机会，奖项设置为200元免房券、20元储值金、5元现金券、5K币/20K币/100K币、10元/20元住房代金券、格林酒店集团会员适用。")]), _vm._v(" "), _c('div', [_vm._v("2.奖券适用于格林旗下格林东方、格美、格雅、格菲、格林豪泰、格盟、青皮树、贝壳8大品牌酒店。")]), _vm._v(" "), _c('div', [_vm._v("活动时间：")]), _vm._v(" "), _c('div', [_vm._v("2018年11月30日-2019年3月29日。")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-23326dde!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Activity/2018HuaTie/index.vue
// module id = 1449
// module chunks = 18